import TeamTable from "./teamTable";

export default TeamTable;
